import { useEffect } from "react";

const WatsonChat = () => {
  useEffect(() => {
    // Avoid multiple instances
    if (window.watsonAssistantChatOptions) {
      console.warn("Watson Chat is already initialized.");
      return;
    }

    function preSendHandler(event) {
      try {
        event.data.context.skills["actions skill"] =
          event.data.context.skills["actions skill"] || {};
        event.data.context.skills["actions skill"].skill_variables =
          event.data.context.skills["actions skill"].skill_variables || {};

        // Set access role based on login status
        const hasToken = !!sessionStorage.getItem("token");

        // If logged in → only "admin"
        // If not logged in → "admin" OR "user"
        const roles = hasToken ? ["admin","user"] : ["user"];

        // Build LIKE conditions
        const likeConditions = roles.map(r => `access like "%${r}%"`).join(" or ");

        event.data.context.skills["actions skill"].skill_variables.filter_to_apply = likeConditions;

        console.log("preSendHandler test:", event);
      } catch (error) {
        console.error("Error in preSendHandler:", error);
      }
    }

    async function onLoad(instance) {
      try {
        await instance.restartConversation();
        instance.on({ type: "pre:send", handler: preSendHandler });
        await instance.render();
      } catch (error) {
        console.error("Error in Watson Assistant onLoad:", error);
      }
    }

    window.watsonAssistantChatOptions = {
      integrationID: "92e0626a-5e90-47f7-be4f-9eb6251b9046", // The ID of this integration.
      region: "wxo-us-south", // The region your integration is hosted in.
      serviceInstanceID: "a21fa5da-8b0d-4caa-abe6-eafec79746fc", // The ID of your service instance.
      clientVersion: "8.5.0",
      headerConfig: {
        showRestartButton: true,
      },
      onLoad: onLoad,
    };

    // Dynamically load Watson Chat script
    const script = document.createElement("script");
    script.src = `https://web-chat.global.assistant.watson.appdomain.cloud/versions/${
      window.watsonAssistantChatOptions.clientVersion || "latest"
    }/WatsonAssistantChatEntry.js`;
    script.async = true;
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(script);
      delete window.watsonAssistantChatOptions;
    };
  }, []);

  return null; // No UI component, just adding script
};

export default WatsonChat;
